module.exports = __webpack_public_path__ + "img/video-call.37582518.svg";